module.exports = __webpack_public_path__ + "static/media/ojt1.3b92482c.png";